export default __webpack_public_path__ + "static/media/14613-403239-15383.12a203a9.jpg";